import {
  TooltipHost as FluentTooltipHost,
  ITooltipHostProps,
  mergeStyleSets
} from "@bps/fluent-ui";

interface TooltipHostProps extends ITooltipHostProps {
  calloutBgColor?: string;
}

export const TooltipHost = ({ calloutBgColor, ...props }: TooltipHostProps) => {
  const calloutPropsStyles = calloutBgColor
    ? {
        beak: { background: calloutBgColor },
        beakCurtain: {
          background: calloutBgColor
        },
        calloutMain: {
          background: calloutBgColor
        }
      }
    : {};

  const tooltipProps: TooltipHostProps["tooltipProps"] = {
    ...props.tooltipProps,
    calloutProps: {
      ...props.tooltipProps?.calloutProps,
      styles: mergeStyleSets(
        calloutPropsStyles,
        props.tooltipProps?.calloutProps?.styles
      )
    }
  };

  return <FluentTooltipHost {...props} tooltipProps={tooltipProps} />;
};
